<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card
          max-width="800"
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('addActivityBoostersTitle') }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text d-none d-sm-block no-break">
            {{ $t('addActivityBoostersDescription') }}
          </v-card-subtitle>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent
          >
            <v-card-subtitle class="text-body-2 greytext--text ">
              {{ $t('addActivityBoostersFieldDescription') }}
            </v-card-subtitle>
            <v-autocomplete
              v-model="selectedUsers"
              :menu-props="{
                rounded: 'xxl'
              }"
              :items="items"
              :loading="isLoading"
              :search-input.sync="search"
              color="white"
              hide-selected
              item-text="searchTerm"
              item-value="id"
              :placeholder="$t('typeToSearch')"
              return-object
              multiple
              chips
              clearable
              solo
              class="rounded-xxl text-body-2 px-1"
              @blur="closeSearch"
              autofocus
              data-testid="users-input"
              @change="change"
            >
              <template v-slot:no-data>
                <p class="mx-5 mt-4">
                  {{ $t('noDataText') }}
                </p>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-if="data.item.type == 'users'"
                  v-bind="data.attrs"
                  close
                  data-testid="user-chip"
                  @click:close="remove(data.item)"
                >
                  <v-avatar left>
                    <v-img
                      v-if="data.item.attributes.avatar_thumb == null"
                      src="../../assets/user_images/profile-avatar.png"
                    />
                    <v-img
                      v-else
                      :src="data.item.attributes.avatar_thumb"
                    />
                  </v-avatar>
                  {{ data.item.attributes.first_name }} {{ data.item.attributes.last_name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar
                  v-if="data.item.type == 'users'"
                  rounded="lg"
                >
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/profile-avatar.png"
                  >
                  <img
                    v-else
                    :src="data.item.attributes.avatar_thumb"
                  >
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-else
                  rounded="lg"
                >
                  <img
                    v-if="data.item.attributes.avatar_thumb == null"
                    src="../../assets/user_images/target-group-avatar.png"
                  >
                </v-list-item-avatar>
                <v-list-item-content v-if="data.item.type == 'users'">
                  <v-list-item-title>{{ data.item.attributes.first_name + ' ' + data.item.attributes.last_name }} </v-list-item-title>
                  <v-list-item-subtitle> {{ data.item.attributes.email }} </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title>{{ data.item.attributes.name }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card>
        <v-row>
          <v-col align="center">
            <FormFooter
              next-button-text="share"
              :loading="loading"
              :cancel-button-link="cancelLink"
              @proceedSubmit="addActivityBoosters"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>             
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { searchSpaceBoostersActivityExcluded } from '../../api/spaceApi'
import { addActivityBoosters } from '../../api/activityApi'
import FormFooter  from '../../components/FormFooter'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        FormFooter,
        AlertMessages
    },
    data () {
        return {
            spaceId: window.$cookies.get('space_id'),
            descriptionLimit: 60,
            selectedUsers: [],
            search: null,
            isLoading: false,
            entries:[],
            alertMsg:'',
            alertValue:false,
            loading: false,
            valid: true,
            activityId: this.$route.params.id,
            //items: [],
            autocompleteRules: [
                v => {
                    if (!v || v.length < 1){
                        return  i18n.t('labelInputRequired');
                    }
                    else return true;
                }
            ],
            errors: [],
            cancelLink: '/activity/'+this.$route.params.id,
            previousRoute: null
        }
    },
    computed: {
        items () {
            return this.entries.map(entry => {
                if (entry.type == 'users') {
                    const searchTerm = entry.attributes.first_name + ' ' + entry.attributes.last_name + ' ' + entry.attributes.email
                    return Object.assign({}, entry, { searchTerm })
                } else if (entry.type == 'target-groups') {
                    const searchTerm = entry.attributes.name
                    return Object.assign({}, entry, { searchTerm })
                }
            })
        },
        selectedUsersEmails() {
            return this.selectedUsers.map(entry => {
                if(entry.attributes.email){
                    return entry.attributes.email
                }
            })
        },
        selectedTargetGroups() {
            return this.selectedUsers.map(entry => {
                if (entry.type == 'target-groups') {
                    if(entry.id){
                        return entry.id
                    }
                }
            })
        }
    },
    watch: {
        async search (val) {
            if (this.isLoading) return 

            var entriesUsers = []
            if(val && val.trim().length >= 2){
                this.isLoading = true
                try {
                    const response = await searchSpaceBoostersActivityExcluded(this.spaceId, this.activityId, val)
                    if(response.status == 200) {
                        // this.entries = response.data.data
                        entriesUsers = response.data.data
                        entriesUsers.forEach(function(item) {
                            item.sort_term = item.attributes.first_name.toLowerCase() + ' ' + item.attributes.last_name.toLowerCase() + ' ' + item.attributes.email.toLowerCase()
                        })
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if(e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }

                this.entries = entriesUsers
                this.isLoading = false
            }

            this.isLoading = false
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path,
                vm.previousRoute = from
            });
        }else { 
            next();
        }
    },
    methods: {
        change(){
            this.search = ''
        },
        remove(item) {
            this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1)
            this.selectedUsers = [...this.selectedUsers]
        },
        closeSearch(){
          this.search = '';
          this.entries = this.selectedUsers.slice();
        },
        async addActivityBoosters(){
            this.$refs.form.validate()
            if(this.valid && (this.selectedUsers.length) ){
                this.loading = true
                try {
                    let data = {
                        data: {
                            type: "activity-users", 
                            attributes: {
                                user_email: this.selectedUsersEmails.filter(n => n),
                            }
                        }
                    };
                    const response = await addActivityBoosters(this.$route.params.id, data)
                    if(response.status == 200) {
                        if(this.previousRoute){
                            if(this.previousRoute.name !== null){
                                var params = this.previousRoute.params
                                params.boostersAddedInActivity = true
                                this.$router.push({name: this.previousRoute.name, params: params})
                            }else {
                                this.$router.push({name: 'ViewActivityPage', params: {id: this.$route.params.id, boostersAddedInActivity: true}})
                            }
                        }else{
                              this.$router.push({name: 'ViewActivityPage', params: {id: this.$route.params.id, boostersAddedInActivity: true}})
                        }
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if(e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if(e.response.status == 404) {
                            this.$router.push({name: 'PageNotFound'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }
                this.loading =false
            }
            
        },
    }
}

</script>